import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

import { UNDERSCORE } from '../../../shared/utils/constant';
import { CalledVolume, Ecalls, GroupCalledVolume } from '../../models/ecall-off-model';
import { DimensionPipe } from '../../../shared/pipes/format-dimension.pipe';
import { DatePipe } from '../../../shared/pipes/date.pipe';

@Component({
	selector: 'copo-called-volume',
	templateUrl: './called-volume.component.html',
	styleUrl: './called-volume.component.css',
	imports: [
		MatIconModule,
		TranslateModule,
		RouterLink,
		NgIf,
		DatePipe,
		DimensionPipe,
	],
})
export class CalledVolumeComponent {
	@Input() showComment?: boolean;
	@Input() volume?: CalledVolume;
	@Input() groupAllVolume?: GroupCalledVolume[] = [];
	ecallData?: Ecalls;
	isLoading = false;
	isOffline = false;
	isReqDateVisible = false;
	isFromToDateVisible = false;
	showComments = false;

	readonly UNDERSCORE = UNDERSCORE;

	getCustomerOrderNumber() {
		if (!this.volume?.customerOrderReference) {
			return undefined;
		}
		if (!this.volume.customerOrderItem) {
			return this.volume.customerOrderReference;
		}
		return `${ this.volume.customerOrderReference }/${ this.volume.customerOrderItem }`;
	}

	getSupplierOrderNumber() {
		if (!this.volume?.supplierOrderReference) {
			return undefined;
		}
		return `${ this.volume.supplierOrderReference }/${ this.volume.supplierOrderItem }`;
	}
}
